import React, { ReactElement } from 'react';
import * as IoC from 'typescript-ioc';

import { IAttendeeNote } from '../../../../../../api/attendees.dao';
import { DateTimeFormatter } from '../../../../../../infrastructure/implementations/date-formatter';
import { DateFnsFormats } from '../../../../../../infrastructure/date-formatter';
import './_attendee-notes-section.scss';
import { ApiDateConverter } from '../../../../../../infrastructure/implementations/api-date-converter';

interface IProps {
    notes: IAttendeeNote[];
    eventTimezone: string;
    title?: string | ReactElement;
}

const dateTimeFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);
const apiDateConverter = IoC.Container.get<ApiDateConverter>(ApiDateConverter);

const AttendeeNotesSection = (props: IProps) => {
    const { notes, eventTimezone, title } = props;

    return (
        <div className='attendee-note-section'>
            {title && <div className='attendee-note-section__note-title'>
                {title}
            </div>}
            { notes.map(({ meetingStartDateTime, note }) => {
                const startDateTime = apiDateConverter.apiStringToDate(meetingStartDateTime as unknown as string);
                const timeStringInEventTimeZone = dateTimeFormatter.dateToFormattedString(
                    startDateTime,
                    dateTimeFormatter.getLocalTimeFormat(),
                    eventTimezone
                );

                const dayStringInEventTimezone = dateTimeFormatter.dateToFormattedString(
                    startDateTime,
                    DateFnsFormats.ShortDayDate,
                    eventTimezone
                );

                return (
                    <div className='attendee-note-section__note' key={meetingStartDateTime.toString()}>
                        <div className='attendee-note-section__note-date'>
                            {`${dayStringInEventTimezone} ${timeStringInEventTimeZone}`}
                        </div>
                        <div className='attendee-note-section__note-content'>
                            {note}
                        </div>
                    </div>
                );
            }
            )}
        </div>
    );
};

export default AttendeeNotesSection;
